import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js';
import { initializeTableSorter } from './stats-table.js';

gsap.registerPlugin(ScrollToPlugin);

/**
 * prime-core.js
 *
 * triggerAjax and postProcessPrimeData live together deliberately:
 * postProcessPrimeData calls triggerAjax recursively for nested .prime-data.v2
 * elements, so separating them would create a circular import.
 *
 * Exports:
 *   triggerAjax(oTheContainer, timeout?)  — fire a prime_v2 AJAX call
 *   postProcessPrimeData(oTheContainer)   — run after any prime_v2 response
 */

// ─── Local-testing helper ───────────────────────────────────────────────────

/**
 * Temporary local-testing workaround: true on a Local by Flywheel install
 * (hostname contains ".local"). Used to point a few hardcoded
 * admin.topphandball.no/apps/... URLs at this site's own services/ port
 * instead — mirrors the same ".local" check in app/kaia.php's match-promo
 * meta box. Remove once services/ fully replaces apps/ in production.
 */
export function isLocalEnv() {
    return window.location.hostname.indexOf('.local') !== -1;
}

// ─── Player card helpers ────────────────────────────────────────────────────

function scaleCardToFit() {
    if ($('body').find('#playercard-modal').length === 0) return;

    const $modal      = $('.modal-body');
    const $card       = $('.card-container');
    const modalWidth  = $modal.width();
    const modalHeight = $modal.height();
    const scale       = Math.min(modalWidth / 1080, modalHeight / 1920);

    $card.css({
        transform      : `scale(${scale}) translate(-50%, -50%)`,
        top            : '50%',
        left           : '50%',
        position       : 'absolute',
        transformOrigin: 'top left',
    });

    $('.modal-body').css({ aspectRatio: '9/16', overflow: 'auto', height: '80vh' });
    }

    function setPlayerCard() {
    if ($('svg#playercard').length === 0 || window.playerCardIsSet === true) return;

    $('svg#playercard').find('.placeholder').each(function() {
        const mybounds = $(this)[0].getBoundingClientRect();
        let modalTop  = 0;
        let modalLeft = 0;

        if ($(this).closest('.modal-content').length > 0) {
        modalTop  = $(this).closest('.modal-content').offset().top;
        modalLeft = $(this).closest('.modal-content').offset().left;
        }

        $('.' + $(this).attr('id')).css({
        top   : (mybounds.top  - modalTop)  + 'px',
        left  : (mybounds.left - modalLeft) + 'px',
        height: mybounds.height + 'px',
        width : mybounds.width  + 'px',
        });
    });

    window.playerCardIsSet = true;
    scaleCardToFit();
}

    // ─── Player rank tables ─────────────────────────────────────────────────────

function processPlayerRanks(oTheContainer) {
    if ($(oTheContainer).find('.player-ranks-wrapper').length === 0) return;

    const limit = 3;

    $('.prime-player-ranks').each(function() {
        let iTheInitialTeamID;
        let iTheSameTeamCount = 0;
        let iTheRowCount      = 0;
        let sTheLastSelectedType = '';

        if ($('body').hasClass('team') || $('body').hasClass('page-template-template-match-program')) {
            $(this).find('.player-rank').each(function() {
                if (iTheRowCount === 0) {
                iTheInitialTeamID = $(this).attr('data-team-id');
                } else if (iTheRowCount > 0 && iTheRowCount <= limit) {
                if ($(this).hasClass('-is-same') && iTheInitialTeamID === $(this).attr('data-team-id')) {
                    iTheSameTeamCount++;
                    sTheLastSelectedType = $(this).attr('data-type');
                } else {
                    iTheSameTeamCount = 0;
                }
                } else if (iTheRowCount > limit) {
                $(this).addClass('-is-hideable').hide();
                }
                iTheRowCount++;
            });

            if (iTheSameTeamCount >= limit) {
                for (let i = limit - 1; i < iTheSameTeamCount; i++) {
                $(this).find('.player-rank').eq(i + 1).addClass('-is-hideable').hide();
                }
                $(this).find('.player-rank').each(function() {
                if (sTheLastSelectedType === 'home' && $(this).hasClass('away')) {
                    $(this).removeClass('-is-hideable').show();
                    return false;
                } else if (sTheLastSelectedType === 'away' && $(this).hasClass('home')) {
                    $(this).removeClass('-is-hideable').show();
                    return false;
                }
                });
            }
        }

        if ($('body').hasClass('nth')) {
            $(this).find('.player-rank').each(function() {
                if (iTheRowCount > limit) {
                $(this).addClass('-is-hideable').hide();
                }
                iTheRowCount++;
            });
        }

        if (iTheRowCount <= 3) {
            $(this).find('.show-all').closest('tr').hide();
        }
    });

    $(document).on('click', '.show-all', function() {
        $(this).closest('tbody').find('.-is-hideable').show();
        $(this).removeClass('show-all').addClass('show-less').find('span').text('Vis færre');
    });

    $(document).on('click', '.show-less', function() {
        $(this).closest('tbody').find('.-is-hideable').hide();
        $(this).removeClass('show-less').addClass('show-all').find('span').text('Vis flere');
        $(window).scrollTop($(this).closest('table').offset().top - 100);
    });
    }

    // ─── Countdown ──────────────────────────────────────────────────────────────

    function processCountdowns(oTheContainer) {
    if (!oTheContainer.find('.countdown-container').length) return;

    oTheContainer.find('.countdown-container').each(function() {
        $(this).countdown($(this).attr('data-time'), function(event) {
        $(this).html(event.strftime(''
            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%D</span><span class="label">dager</span></div></div></div>'
            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%H</span><span class="label">timer</span></div></div></div>'
            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%M</span><span class="label">min</span></div></div></div>'
            + '<div class="column"><div class="countdown"><div class="box"><span class="value">%S</span><span class="label">sek</span></div></div></div>'
        ));
        });
    });
    }

    // ─── Stats navigation auto-trigger ─────────────────────────────────────────

    function processStatsNavigation() {
    if ($('.prime-stats-section').length === 0 || window.bTheInitial !== true) return;

    if (window.getUrlParameter('prime_type') === 'tournament') {
        if ($('.prime-stats-section .prime-tournaments').find('option').length > 1 && $('.prime-stats-section').attr('data-tournament-id')) {
            window.bTheInitial = false;
            $('.prime-stats-section .prime-tournaments').val($('.prime-stats-section').attr('data-tournament-id')).change().removeClass('-is-ready');
            $('.prime-stats-filter').click();
            // Remove all URL parameters from the address bar
            /*if (window.history && window.history.replaceState) {
                const cleanUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
                window.history.replaceState({}, document.title, cleanUrl);
            }*/
        
        }
    }

    if (window.getUrlParameter('prime_type') === 'team') {
        if ($('.prime-stats-section .prime-tournaments.-is-ready').find('option').length > 1 && $('.prime-stats-section').attr('data-tournament-id')) {
            $('.prime-stats-section .prime-tournaments').val($('.prime-stats-section').attr ('data-tournament-id')).change().removeClass('-is-ready');
        }
        if ($('.prime-stats-section .prime-teams option').length > 1 && $('.prime-stats-section').attr('data-team-id')) {
            window.bTheInitial = false;
            $('.prime-stats-section .prime-teams').val($('.prime-stats-section').attr('data-team-id')).change().removeClass('v2');
            $('.prime-stats-filter').click();
            /*if (window.history && window.history.replaceState) {
                const cleanUrl = window.location.protocol + '//' + window.location.host + window.location.pathname;
                window.history.replaceState({}, document.title, cleanUrl);
            }*/
            
        }
    }
    }

    // ─── Hero scroll ────────────────────────────────────────────────────────────

    let nth_hero_scrolled = false;

    function processHeroScroll(oTheContainer) {
    if ($('body.team.home').length > 0 && oTheContainer.hasClass('prime-hero')) {
        let top = 0;
        if (window.iTheWidth < window.iTheHeight) {
            $('.hero-content').css({ 'background-size': 'auto calc(100vh - ' + top + 'px)', 'background-position': 'center 0px' });
            $('.hero-content').css({ height: 'calc(100vh - ' + top + 'px)' });
            top = $('.single-match-info').outerHeight();
        } else {
            $('.hero-content').css({ 'background-size': 'cover', 'background-position': 'center center' });
            top = $('.single-match-info').outerHeight();
        }
        const mTop = parseInt($('.single-match-info').css('padding-top'), 10);
        $('.hero-content').addClass('-is-loaded');
        if ($(window).scrollTop() === 0) {
            gsap.to(window, { scrollTo: top + mTop + mTop, delay: 0.5 });
        }
    }

    if ($('body.nth.home').length > 0 && oTheContainer.closest('section').hasClass('prime-match-slider-outer') && nth_hero_scrolled === false) {
        nth_hero_scrolled = true;
        const mTop = parseInt($('.prime-match-slider-outer').css('margin-top'), 10);
        const top  = $('.prime-match-slider-outer').outerHeight() + mTop * 2;
        if ($(window).scrollTop() === 0) {
            gsap.to(window, { scrollTo: top, delay: 0.5 });
        }
    }
}

// ─── postProcessPrimeData ───────────────────────────────────────────────────

export function postProcessPrimeData(oTheContainer) {
    processHeroScroll(oTheContainer);
    processPlayerRanks(oTheContainer);
    processCountdowns(oTheContainer);

    if ($('body').hasClass('page-template-template-stats')
        || $('body').hasClass('page-template-template-player')
        || $('.single-match-stats-wrapper').length > 0) {
        initializeTableSorter('body');
    }

    if ($('.content-screen.stats').length > 0) {
        initializeTableSorter('.content-screen.stats');
    }

    if (oTheContainer.find('.prime-combine-selected').length === 1) {
        $('.prime-combine-selected').click();
    }

    processStatsNavigation();
    setPlayerCard();

    // Use jQuery for modal logic, and handle dynamically loaded .open-player-card-modal elements
    const $modal = $('#playerCardModal');
    const $iframe = $('#playerCardIframe');
    const $closeBtn = $('#closePlayerCardModal');

    // Delegate click event for dynamically loaded buttons
    $(document).on('click', '.open-player-card-modal', function(e) {
        e.preventDefault();
        const playerId = $(this).data('player-id');
        const contextId = $(this).data('context-id');
        const base = isLocalEnv()
            ? window.location.protocol + '//' + window.location.host + '/services/player-card'
            : 'https://admin.topphandball.no/apps/player-card';
        const url = base + '/?player_id=' + encodeURIComponent(playerId) + '&context_id=' + encodeURIComponent(contextId) + '&type=tournament&download=true';
        $iframe.attr('src', url);
        $modal.css('display', 'flex');
    });

    // Close modal on close button click
    $closeBtn.on('click', function() {
        $modal.css('display', 'none');
        $iframe.attr('src', '');
    });
    // Optional: close modal on background click
    $modal.on('click', function(e) {
        if (e.target === this) {
            $modal.css('display', 'none');
            $iframe.attr('src', '');
        }
    });

    // Recurse into nested .prime-data.v2 elements
    oTheContainer.find('.prime-data.v2').each(function() {
        const oTheInner = $(this);
        oTheInner.addClass('-is-loading-resources').empty().append(window.sTheLoader);

        window.Ajax.prime_v2(
        {
            template   : oTheInner.attr('data-content-template'),
            id         : oTheInner.attr('data-id'),
            queryString: oTheInner.attr('data-content-query'),
            queryType  : oTheInner.attr('data-query-type'),
            homeTeam   : oTheInner.attr('data-home-team'),
            awayTeam   : oTheInner.attr('data-away-team'),
            match      : oTheInner.attr('data-match'),
            container  : oTheInner.attr('data-content-container'),
        },
        function(data) {
            $(data.param.container).removeClass('-is-loading-resources').empty().append(data.markup);
            postProcessPrimeData($(data.param.container));
            $(data.param.container).closest('.col').find('.prime-matches-single-info-title').removeClass('d-none');
        },
        function(data) {
            window.showError(data);
        }
        );
    });
}

// ─── triggerAjax ────────────────────────────────────────────────────────────

export function triggerAjax(oTheContainer, timeout = null) {
    window.Ajax.prime_v2(
        {
        template   : oTheContainer.attr('data-content-template'),
        id         : oTheContainer.attr('data-id'),
        queryString: oTheContainer.attr('data-content-query'),
        queryType  : oTheContainer.attr('data-query-type'),
        homeTeam   : oTheContainer.attr('data-home-team'),
        awayTeam   : oTheContainer.attr('data-away-team'),
        match      : oTheContainer.attr('data-match'),
        container  : oTheContainer.attr('data-content-container'),
        },
        function(data) {
        if (timeout) clearTimeout(timeout);
        if (!data.param) return;

        if ($(data.param.container).hasClass('prime-matches-horizontal') && data.count === 0) {
            $(data.param.container).find('.nav .nav-item').last().find('button').addClass('active');
        }

        $(data.param.container).removeClass('-is-loading-resources').empty().append(data.markup);
        postProcessPrimeData($(data.param.container));
        $(data.param.container).closest('.col').find('.prime-matches-single-info-title').removeClass('d-none');
        $(data.param.container).attr('data-count', data.count);

        if (data.count === 0 && $(data.param.container).hasClass('-if-empty-remove')) {
            const $tabPane = $(data.param.container).closest('.tab-pane');
            if ($tabPane.length) {
            $tabPane.closest('.tab-content').find('.tab-pane:not(.active)').addClass('active show');
            $tabPane.removeClass('active show');
            $(data.param.container).closest('.prime-match-slider-outer').find('.nav-link').each(function() {
                if ($(this).hasClass('active')) {
                $(this).removeClass('active').closest('.nav-item').remove();
                } else {
                $(this).addClass('active').css({ 'pointer-events': 'none' });
                }
            });
            }
            $(data.param.container).remove();
        }
        },
        function(data) {
        if (timeout) clearTimeout(timeout);
        window.showError(data);
        }
    );
}

// ─── Public init ─────────────────────────────────────────────────────────────

export function initPrimeCore() {
    window.playerCardIsSet = false;

    // Seed scale handler on resize
    $(window).on('resize', scaleCardToFit);
    scaleCardToFit();
    setPlayerCard();

    // Initial load of all .prime-data.v2 elements
    $('body').find('.prime-data.v2').each(function(i) {
        const oTheContainer = $(this);
        const delay         = (i + 1) * 100;

        const isEager = oTheContainer.hasClass('prime-hero')
        || oTheContainer.hasClass('prime-single-player-header')
        || oTheContainer.hasClass('prime-single-player-stats')
        || oTheContainer.closest('select').length === 1;

        if (isEager) {
        if (oTheContainer.hasClass('prime-single-player-header')) {
            oTheContainer.empty().addClass('-is-loading-resources').append(window.sTheLoader);
        }
        setTimeout(() => triggerAjax(oTheContainer), delay);
        } else {
        oTheContainer.empty().addClass('-is-loading-resources').append(window.sTheLoader);

        setTimeout(() => {
            const timeout = setTimeout(() => {
            oTheContainer.empty().append(`
                <div class="timeout-message">
                Oops! Det tok lenger tid enn vi ønsket å hente data.
                <button class="retry-button prime-icon">Forsøk igjen!</button>
                </div>
            `);
            oTheContainer.find('.retry-button').on('click', function() {
                oTheContainer.find('.timeout-message').remove();
                oTheContainer.append(window.sTheLoader);
                triggerAjax(oTheContainer, timeout);
            });
            }, 100000);

            triggerAjax(oTheContainer, timeout);
        }, delay);
        }
    });
}



// WEBPACK FOOTER //
// ./scripts/routes/common/prime-core.js